export const MASCOT_URL = "/brand/paw-logo.webp";

export const FOURTHWALL_URL = "https://purp-alert-network-llc-shop.fourthwall.com/";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
    creatorDesk: "/brand/creator-desk.webp",
    videoFilm: "/brand/video-film.webp",
    originalMusic: "/brand/original-music.webp",
    fashion: "/brand/fashion.webp",
    ownerSelfie: "/brand/owner-selfie.webp",
    characterPortrait: "/brand/character-portrait.webp",
    throne: "/brand/throne.webp",
    idea: "/brand/scene-idea.webp",
    action: "/brand/scene-action.webp",
};

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/#explore", label: "Explore" },
    { to: "/about", label: "About" },
    { to: "/pan-school", label: "PAN School" },
    { to: "/my-5", label: "MY 5" },
    { to: "/media", label: "Media" },
    { to: FOURTHWALL_URL, label: "Shop" },
];

export const MORE_LINKS = [
    { to: "/create-build", label: "Create / Build" },
    { to: "/community", label: "Community" },
    { to: "/gallery", label: "Gallery" },
    { to: "/get-involved", label: "Get Involved" },
];

export const PANELS = {
    faith: "/mascot/panel-1.webp",
    church: "/mascot/panel-2.webp",
    gaming: "/mascot/panel-3.webp",
    studio: "/mascot/panel-4.webp",
    puzzle: "/mascot/panel-5.webp",
    director: "/mascot/panel-6.webp",
    stage: "/mascot/panel-7.webp",
    art: "/mascot/panel-8.webp",
    income: "/mascot/panel-9.webp",
};

export const GALLERY_SCENES = [
    { src: PANELS.faith, title: "The Word" },
    { src: PANELS.church, title: "The Church" },
    { src: PANELS.gaming, title: "Game On" },
    { src: PANELS.studio, title: "The Studio" },
    { src: PANELS.puzzle, title: "The Blueprint" },
    { src: PANELS.director, title: "Director's Chair" },
    { src: PANELS.stage, title: "Center Stage" },
    { src: PANELS.art, title: "The Canvas" },
    { src: PANELS.income, title: "The Payoff" },
];

export const RADIO_LOGO = "/brand/radio-logo.webp";

export const SOCIAL_LINKS = [
    { id: "instagram", label: "Instagram", url: "https://instagram.com/PURPALERT.MUSIC" },
    { id: "tiktok", label: "TikTok", url: "https://tiktok.com/@PURPALERTNETWORK" },
    { id: "x", label: "X", url: "https://x.com/PurpAlertNetWrk" },
    { id: "youtube", label: "YouTube", url: "https://youtube.com/@PurpAlert" },
];

export function TikTokIcon({ className = "w-5 h-5" }) {
    return (
        <svg viewBox="0 0 448 512" className={className} fill="currentColor" aria-hidden="true">
            <path d="M448,209.9a210.1,210.1,0,0,1-122.8-39.3V349.4A162.6,162.6,0,1,1,185,188.3V278.2a74.6,74.6,0,1,0,52.2,71.2V0L237.2,0h88A210.6,210.6,0,0,0,448,209.9z" />
        </svg>
    );
}

export function XIcon({ className = "w-5 h-5" }) {
    return (
        <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
    );
}

export const KITTY = {
    streetwear: "/brand/kitty-1.webp",
    laugh: "/brand/kitty-2.webp",
    thinking: "/brand/kitty-3.webp",
    question: "/brand/kitty-4.webp",
    bible: "/brand/kitty-5.webp",
    pointing: "/brand/kitty-6.webp",
    city: "/brand/kitty-7.webp",
    library: "/brand/kitty-8.webp",
    inYoCity: "/brand/kitty-9.webp",
};

export const POSTERS = [
    { src: "/brand/poster-3.webp", title: "Neon Focus" },
    { src: "/brand/poster-4.webp", title: "Skyline" },
    { src: "/brand/poster-5.webp", title: "Ring Light" },
];

export const NEW_SCENES = [
    { src: "/brand/scene-point.webp", title: "You. Yes, You." },
    { src: "/brand/scene-walk.webp", title: "The Ride" },
    { src: "/brand/scene-chess.webp", title: "The Game Plan" },
    { src: "/brand/scene-stance.webp", title: "The Stance" },
    { src: "/brand/scene-peace.webp", title: "Peace" },
];

export const KITTY_SCENES = [
    { src: KITTY.streetwear, title: "Kitty — The Fit" },
    { src: KITTY.laugh, title: "Kitty — The Laugh" },
    { src: KITTY.thinking, title: "Kitty — Deep Thought" },
    { src: KITTY.question, title: "Kitty — The Question" },
    { src: KITTY.bible, title: "Kitty — The Book" },
    { src: KITTY.pointing, title: "Kitty — You" },
    { src: KITTY.city, title: "Kitty — City Crouch" },
    { src: KITTY.library, title: "Kitty — The Library" },
    { src: KITTY.inYoCity, title: "Kitty — In Yo City" },
];

export const HERO_SCENES = [...GALLERY_SCENES, ...NEW_SCENES, ...KITTY_SCENES];

export const MY5_CATEGORIES = [    { id: "facts", label: "Facts" },
    { id: "hot-takes", label: "Hot Takes" },
    { id: "faith", label: "Christian Content" },
    { id: "music", label: "Music Reviews" },
    { id: "tv-movies", label: "TV & Movies" },
    { id: "storytimes", label: "Storytimes" },
    { id: "journaling", label: "Journaling" },
    { id: "art", label: "Art" },
    { id: "fashion", label: "Fashion" },
    { id: "gaming", label: "Gaming" },
    { id: "live", label: "Live Content" },
];

export const my5Label = (id) => MY5_CATEGORIES.find((c) => c.id === id)?.label || id;

export async function apiPost(path, body) {
    return apiFetch(path, { method: "POST", body });
}

export async function apiFetch(path, { method = "GET", body, token } = {}) {
    const res = await fetch(`${API}${path}`, {
        method,
        headers: {
            ...(body ? { "Content-Type": "application/json" } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
        let detail = `Request failed (${res.status})`;
        try {
            const d = await res.json();
            if (typeof d.detail === "string") detail = d.detail;
        } catch {}
        throw new Error(detail);
    }
    return res.json();
}

export function PawIcon({ className = "w-5 h-5" }) {
    return (
        <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
            <g fill="currentColor">
                <ellipse cx="14" cy="27" rx="6" ry="8" transform="rotate(-14 14 27)" />
                <ellipse cx="25" cy="18" rx="6" ry="8" transform="rotate(-5 25 18)" />
                <ellipse cx="39" cy="18" rx="6" ry="8" transform="rotate(5 39 18)" />
                <ellipse cx="50" cy="27" rx="6" ry="8" transform="rotate(14 50 27)" />
                <path d="M32 33c8 0 15 6 15 13 0 5-4 8-9 8-3 0-4-1-6-1s-3 1-6 1c-5 0-9-3-9-8 0-7 7-13 15-13z" />
            </g>
        </svg>
    );
}
